import { GraphQLScalarType, Kind } from 'graphql'

export const HicDateResolver = new GraphQLScalarType({
  name: 'Date',
  description:
    'A date string, such as 2007-12-03, compliant with the `full-date` ' +
    'format outlined in section 5.6 of the RFC 3339 profile of the ' +
    'ISO 8601 standard for representation of dates and times using ' +
    'the Gregorian calendar.',
  serialize(value) {
    if (value instanceof Date) {
      if (validateJSDate(value)) {
        return serializeDate(value)
      }
      throw new TypeError('Date cannot represent an invalid Date instance')
    } else if (typeof value === 'string') {
      if (validateDate(value)) {
        return value
      }
      throw new TypeError(`Date cannot represent an invalid date-string ${value}.`)
    } else {
      throw new TypeError('Date cannot represent a non string, or non Date type ' + JSON.stringify(value))
    }
  },
  parseValue(value) {
    if (!(typeof value === 'string')) {
      throw new TypeError(`Date cannot represent non string type ${JSON.stringify(value)}`)
    }
    if (validateDate(value)) {
      return parseDate(value)
    }
    throw new TypeError(`Date cannot represent an invalid date-string ${value}.`)
  },
  parseLiteral(ast) {
    if (ast.kind !== Kind.STRING) {
      throw new TypeError(`Date cannot represent non string type ${'value' in ast && ast.value}`)
    }
    const { value } = ast
    if (validateDate(value)) {
      return parseDate(value)
    }
    throw new TypeError(`Date cannot represent an invalid date-string ${String(value)}.`)
  },
  extensions: {
    codegenScalarType: 'Date | string',
  },
})

export const validateJSDate = (date: Date) => {
  const time = date.getTime()
  return time === time // eslint-disable-line
}

export const serializeDate = (date: Date) => {
  const utcStartOfTheDay = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()))
  return utcStartOfTheDay.toISOString().split('T')[0]
}

const leapYear = (year: number) => {
  return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0
}

export const validateDate = (datestring: string) => {
  const RFC_3339_REGEX = /^(\d{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01]))$/
  if (!RFC_3339_REGEX.test(datestring)) {
    return false
  }
  // Verify the correct number of days for
  // the month contained in the date-string.
  const year = Number(datestring.substr(0, 4))
  const month = Number(datestring.substr(5, 2))
  const day = Number(datestring.substr(8, 2))
  switch (month) {
    case 2: // February
      if (leapYear(year) && day > 29) {
        return false
      } else if (!leapYear(year) && day > 28) {
        return false
      }
      return true
    case 4: // April
    case 6: // June
    case 9: // September
    case 11: // November
      if (day > 30) {
        return false
      }
      break
  }
  return true
}

export const parseDate = (date: string) => {
  const strs = date.split('-').map((s) => parseInt(s))
  return new Date(strs[0], strs[1] - 1, strs[2])
}
